// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.old-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.old-container.wrap {
  flex-wrap: wrap;
}
.old-container .box.col {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.old-container .box.col > div {
  width: 100%;
}
.old-container .box.row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.old-container form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.old-container form > .box.col {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .old-container form > .box.col {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .old-container, .col, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .old-container, .col, form {
    padding: 0px;
  }
}
.text-overflow-hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.icon {
  color: var(--accent-color);
}

.richtext-output-wrap .se-video-container figure {
  padding-bottom: 0 !important;
}

.se-wrapper-inner.se-wrapper-wysiwyg {
  margin: 20px 0;
  max-width: 350px;
  width: 350px;
  margin: 0 auto;
  background-color: #212121;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.35);
}

.se-wrapper {
  padding: 20px 0;
}

.sun-editor {
  background-color: #212121;
  border-color: #3d3d3d !important;
}
.sun-editor .se-container {
  background-color: grey;
}
.sun-editor .se-toolbar.sun-editor-common {
  background-color: #212121;
  outline-color: #3d3d3d;
}
.sun-editor .se-btn-module {
  border-color: #3d3d3d;
}
.sun-editor .se-btn-module .se-btn {
  color: #cecece;
  box-shadow: unset !important;
}
.sun-editor .se-btn-module .se-btn:enabled.active {
  color: var(--accent-color);
}
.sun-editor .se-btn-module .se-btn:enabled.active:hover, .sun-editor .se-btn-module .se-btn.active:hover {
  background-color: #3d3d3d;
  color: #cecece;
}
.sun-editor .se-btn-module .se-btn:enabled.active:hover svg, .sun-editor .se-btn-module .se-btn.active:hover svg {
  color: #cecece;
}
.sun-editor .se-btn-module .se-btn:enabled.on {
  color: #cecece;
  background-color: #3d3d3d;
}
.sun-editor .se-btn-module .se-btn:hover, .sun-editor .se-btn-module .se-btn:enabled:hover {
  color: #cecece;
  background-color: #3d3d3d;
}
.sun-editor .se-btn-module .se-btn:disabled {
  color: #757575;
}
.sun-editor .se-btn-module .se-btn.on {
  background-color: #3d3d3d;
}
.sun-editor .se-btn-module .se-btn:enabled.on:hover {
  background-color: #3d3d3d;
}
.sun-editor .se-btn-module .se-btn:enabled:active {
  background-color: #3d3d3d;
  box-shadow: unset;
}
.sun-editor .se-resizing-bar.sun-editor-common {
  background-color: #3d3d3d;
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/components/WSIGEditor/suneditor_dark_theme.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AAzEA;EACI,cAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,gDAAA;AA4EJ;;AA1EA;EACI,eAAA;AA6EJ;;AA3EA;EACI,yBAAA;EACA,gCAAA;AA8EJ;AA7EI;EACI,sBAAA;AA+ER;AA9EI;EACI,yBAAA;EACA,sBAAA;AAgFR;AA/EI;EACI,qBAAA;AAiFR;AAhFQ;EACI,cAAA;EACA,4BAAA;AAkFZ;AAjFY;EACI,0BDTP;AC4FT;AAlFY;EACI,yBAAA;EACA,cAAA;AAoFhB;AAnFgB;EACI,cAAA;AAqFpB;AApFY;EACI,cAAA;EACA,yBAAA;AAsFhB;AArFY;EACI,cAAA;EACA,yBAAA;AAuFhB;AAtFY;EACI,cAAA;AAwFhB;AAvFY;EACI,yBAAA;AAyFhB;AAxFY;EACI,yBAAA;AA0FhB;AAzFY;EACI,yBAAA;EACA,iBAAA;AA2FhB;AA1FI;EACI,yBAAA;AA4FR","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","@import '../../sass/settings'\n\n.se-wrapper-inner.se-wrapper-wysiwyg\n    margin: 20px 0\n    max-width: 350px\n    width: 350px\n    margin: 0 auto\n    background-color: #212121\n    box-shadow: 0px 5px 10px 0px rgba(#000, 0.35)\n\n.se-wrapper\n    padding: 20px 0\n\n.sun-editor\n    background-color: #212121\n    border-color: #3d3d3d !important\n    .se-container\n        background-color: grey\n    .se-toolbar.sun-editor-common\n        background-color: #212121\n        outline-color: #3d3d3d\n    .se-btn-module\n        border-color: #3d3d3d\n        .se-btn\n            color: #cecece\n            box-shadow: unset !important\n            &:enabled.active\n                color: $accent\n            &:enabled.active:hover, &.active:hover\n                background-color: #3d3d3d\n                color: #cecece\n                svg\n                    color: #cecece\n            &:enabled.on\n                color: #cecece\n                background-color: #3d3d3d\n            &:hover, &:enabled:hover\n                color: #cecece\n                background-color: #3d3d3d\n            &:disabled\n                color: #757575\n            &.on\n                background-color: #3d3d3d\n            &:enabled.on:hover\n                background-color: #3d3d3d\n            &:enabled:active\n                background-color: #3d3d3d\n                box-shadow: unset\n    .se-resizing-bar.sun-editor-common\n        background-color: #3d3d3d"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
